import * as React from "react";
import { Link } from "react-router-dom";
import makeStyles from '@mui/styles/makeStyles';
import clsx from "clsx";
export interface Props {
  children: React.ReactNode;
  href: string;
  buttonLink?: boolean;
  onClick?: (e: any) => void;
  className?: string;
  from?: string;
  currentUrl?: string;
  id?: string;
}

const useStyles = makeStyles(() => ({
  linkStyle: {
    "color": "#0033FF",
    "textDecoration": "underline",
    "&:visited": {
      color: "#9900CC",
    },
    "&:focus, &:hover": {
      color: "#BB3300",
    },
    "&:active": {
      color: "#663300",
    },
  },
}));

export default function RouterLink({
  href,
  children,
  buttonLink,
  onClick,
  id,
  currentUrl,
  className,
  from,
}: Props) {
  const classes = useStyles();
  const splitHref = href.split("?");
  return (
    <Link
      id={id}
      className={clsx(buttonLink ? "" : classes.linkStyle, className)}
      onClick={onClick}
      to={{
        pathname: splitHref[0],
        search: splitHref[1],
        state: { url: currentUrl, from: from },
      }}
    >
      {children}
    </Link>
  );
}
